import React, {Suspense} from 'react'

import invoiceQuery, {} from '../../../__generated__/InvoiceQuery.graphql'
import useQueryLoaderNow from '../../../hooks/useQueryLoaderNow'
import Invoice from '../components/Invoice/Invoice'



const InvoiceRoot = ({
  match: {
    params: {invoiceId}
  }
}) => {
  const queryRef = useQueryLoaderNow(invoiceQuery, {invoiceId})
  return React.createElement(Suspense, { fallback: '',}, queryRef && React.createElement(Invoice, { queryRef: queryRef,} ))
}

export default InvoiceRoot
